/* eslint-disable react/prop-types */
import * as React from 'react';

import { Slider } from 'antd';

const PrimitiveSlider = React.forwardRef<
  React.ElementRef<typeof Slider>,
  React.ComponentPropsWithoutRef<typeof Slider>
>(
  (
    {
      min = 0,
      max = 1,
      step = 0.05,
      marks = {
        0: 0,
        1: 1,
      },
      tooltip = { placement: 'bottom' },
      ...props
    },
    ref,
  ) => (
    <Slider
      ref={ref}
      min={min}
      max={max}
      step={step}
      marks={marks}
      tooltip={tooltip}
      {...props}
    />
  ),
);
PrimitiveSlider.displayName = 'PrimitiveSlider';

export { PrimitiveSlider };
